<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<div class="mgb_5">
					<em class="lt_text">Valid Receipt Date</em>
					<span class="mgr_15"> <CustomDatePicker v-model="from_date"/> ~ <CustomDatePicker v-model="to_date"/></span>

					<em class="lt_text">Receipt Type</em>
					<span class="int_type_no_border mgr_5">
						<label>
							<select v-model="receipt_type" class="tbl_select">
								<option value="" selected> All</option>
								<option v-for="type in receiptTypeList" :value="type.code" :key="type.code">{{ type.name }}</option>
							</select>
						</label>
					</span>

					<span class="int_type_no_border mgr_15">
						<input type="checkbox" class="int_type" v-model="receipt_type_exclude_yn" id="exclude" :disabled="!receipt_type" />
						<label class="lt_text" for="exclude">Exclude</label>
					</span>

					<em class="lt_text">Sales Group</em>
					<span class="int_type_no_border mgr_15"><CodeSelect className="tbl_select" :codes="salesGroups" :displayDescription="true" v-model="sales_group_code"/></span>

					<span class="int_type_no_border mgr_15">
						<PartnerSelect v-model="bill_to_code" ph="Bill To" :showName="false" @set-partner="setPartner" />
					</span>

					<span class="int_type_no_border mgr_5">
						<input type="checkbox" class="int_type" v-model="bounced" id="bounced" />
						<label class="lt_text" for="bounced">Bounced</label>
					</span>

					<span v-if="['minkhair', 'newjigu'].includes(company_id)" class="int_type_no_border mgr_15">
						<input type="checkbox" class="int_type" v-model="valid_only" id="valid_only" />
						<label class="lt_text" for="valid_only">Valid Only</label>
					</span>
				</div>

				<div>
					<span class="int_type_no_border mgr_10">
						<label class="lt_text">
							<input type="checkbox" ref="summary_bill_to" class="int_type" @change="changeTable('BILLTO')" />
							<em>Summary(Bill To)</em>
						</label>
					</span>

					<span class="int_type_no_border mgr_15">
						<label class="lt_text">
							<input type="checkbox" ref="summary_date" class="int_type" @change="changeTable('DATE')" />
							<em>Summary(Date)</em>
						</label>
					</span>

					<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
					<a href="javascript:void(0);" class="gray_bt mgr_15" @click="reset()">Reset</a>
				</div>
			</div>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%">
				<template v-if="!is_date_summary">
					<table v-if="!is_summary" class="list_tbl sticky_list_tbl" v-columns-resizable>
						<colgroup>
							<col style="width: 4%;" />
							<col style="width: 4%;" />
							<col style="width: 5%;" />
							<col style="width: 7%;" />
							<col style="width: 7%;" />
							<col />
							<col style="width: 4%;" />
							<col style="width: 6%;" />
							<col style="width: 7%;" />
							<col style="width: 6%;" />
							<col style="width: 6%;" />
							<col style="width: 6%;" />
							<col style="width: 5%;" />
							<col style="width: 4%;" />
							<col style="width: 6%;" />
						</colgroup>
						<thead>
							<tr>
								<th>No</th>
								<th>Receipt Type</th>
								<th>
									<a href="javascript:void(0);" @click="sort('valid_receipt_date')">Valid Receipt Date{{ sortMark('valid_receipt_date') }}</a>
								</th>
								<th>Sales Grp</th>
								<th>
									<a href="javascript:void(0);" @click="sort('bill_to')">Bill To{{ sortMark('bill_to') }}</a>
								</th>
								<th>Bill To Name</th>
								<th>STATE</th>
								<th>
									<a href="javascript:void(0);" @click="sort('receipt_amt')">Receipt Amt{{ sortMark('receipt_amt') }}</a>
								</th>
								<th>Billing No</th>
								<th>Invoice Amt</th>
								<th>AR Amount</th>
								<th>Check No</th>
								<th>Payment Term</th>
								<th>Past Due Date</th>
								<th>Receipt<br />Remarks</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="type in root">
								<tr v-bind:key="type.code">
									<td colspan="15" class="al_left">{{ type.receipt_type_code }} {{ type.receipt_type_name }}</td>
								</tr>
								<template v-for="date in type.receiptTypeDateList">
									<template v-for="bill in date.billList">
										<tr v-for="(invoice, index) in bill.receiptItemList" v-bind:key="invoice.index">
											<td class="al_center">{{ invoice.index }}</td>
											<td class="al_center">{{ type.receipt_type_code }}</td>
											<!-- <td class="al_center" v-bind:rowspan="bill.row_count" v-if="invoice.row_index">{{ date.receipt_date }}</td>
								<td class="al_left" v-bind:rowspan="bill.row_count" v-if="invoice.row_index">{{ bill.sales_group_name }}</td>
								<td class="al_left" v-bind:rowspan="bill.row_count" v-if="invoice.row_index">{{ bill.bill_to_code }}</td>
								<td class="al_left" v-bind:rowspan="bill.row_count" v-if="invoice.row_index">{{ bill.bill_to_name }}</td>
								<td class="al_center" v-bind:rowspan="bill.row_count" v-if="invoice.row_index">{{ bill.bill_address_state }}</td>
								<td class="al_right" v-bind:rowspan="bill.row_count" v-if="invoice.row_index">{{ bill.receipt_amount | toCurrencyZeroNull }}</td> -->

											<template v-if="index === 0 || (index > 0 && invoice.receipt_item_no !== bill.receiptItemList[index - 1].receipt_item_no)">
												<td class="al_center">{{ date.valid_receipt_date }}</td>
												<td class="al_left">{{ bill.sales_group_name }}</td>
												<td class="al_left">{{ bill.bill_to_code }}</td>
												<td class="al_left truncate" :title="bill.bill_to_name">{{ bill.bill_to_name }}</td>
												<td class="al_center">{{ bill.bill_address_state }}</td>
												<!-- bill.receipt_amount는 bill.receiptItemList 각 요소를 receipt_item_no로 그룹핑했을 때, 각 그룹에 해당하는 receipt_item_amount의 합임.(java service에서 계산) -->
												<!-- 단, 한 receipt데이터를 type이 같은 receipt_item데이터가 참조하는 경우는 거의 없으므로(위 그룹핑 결과, 거의 그룹이 1개임.) -->
												<!-- bill.receipt_amount를 receipt_item의 amount로 볼 수 있음. (단, Check같은 경우 1개의 receipt데이터를 type이 같은 receipt_item데이터가 참조할 수 있음.)  -->
												<td class="al_right">{{ invoice.receipt_item_amount | toCurrencyZeroNull }}</td>
												<!-- bill.receipt_amount -->
											</template>
											<template v-else>
												<td colspan="6"></td>
											</template>

											<td class="al_right">{{ invoice.invoice_dn }}</td>
											<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
											<!-- <td class="al_right">{{ invoice.receipt_item_amount | toCurrencyZeroNull }}</td> -->
											<td class="al_right">{{ invoice.ar_amount | toCurrencyZeroNull }}</td>
											<td class="al_left">{{ invoice.check_no }}</td>
											<td class="al_center">{{ invoice.payment_term_code }}</td>
											<td class="al_right">{{ invoice.past_due_date | commaSeparated }}</td>
											<td class="al_left">{{ invoice.receipt_remark }}</td>
										</tr>
									</template>
								</template>
								<tr v-bind:key="type.code">
									<td colspan="7" class="al_right">Sub Total</td>
									<td class="al_right">{{ type.total_amount | toCurrency }}</td>
									<td colspan="7"></td>
								</tr>
							</template>
							<tr>
								<td colspan="7" class="al_right">Grand Total</td>
								<td class="al_right">{{ grandTotal | toCurrency }}</td>
								<td colspan="7"></td>
							</tr>
						</tbody>
					</table>

					<table v-else class="list_tbl sticky_list_tbl" v-columns-resizable>
						<colgroup>
							<col style="width: 5%;" />
							<col style="width: 6%;" />
							<col style="width: 8%;" />
							<col style="width: 8%;" />
							<col />
							<col style="width: 10%;" />
							<col style="width: 20%;" />
						</colgroup>
						<thead>
							<tr>
								<th>No</th>
								<th>Receipt Type</th>
								<th>
									<a href="javascript:void(0);" @click="sort('valid_receipt_date')">Valid Receipt Date{{ sortMark('valid_receipt_date') }}</a>
								</th>
								<th>
									<a href="javascript:void(0);" @click="sort('bill_to')">Bill To{{ sortMark('bill_to') }}</a>
								</th>
								<th>Bill To Name</th>
								<th>Receipt Amt</th>
								<th>Check No</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="type in root">
								<tr v-bind:key="type.code">
									<td colspan="7" class="al_left">{{ type.receipt_type_code }} {{ type.receipt_type_name }}</td>
								</tr>
								<template v-for="date in type.receiptTypeDateList">
									<template v-for="bill in date.billList">
										<tr v-for="summary in bill.summary_list" v-bind:key="summary.index">
											<td class="al_center">{{ summary.index }}</td>
											<td class="al_center">{{ type.receipt_type_code }}</td>
											<td class="al_center">{{ date.valid_receipt_date }}</td>
											<td class="al_left">{{ bill.bill_to_code }}</td>
											<td class="al_left truncate" :title="bill.bill_to_name">{{ bill.bill_to_name }}</td>
											<td class="al_right">{{ summary.receipt_item_amount | toCurrencyZeroNull }}</td>
											<td class="al_left">{{ summary.check_no }}</td>
										</tr>
									</template>
								</template>
								<tr v-bind:key="type.code">
									<td colspan="5" class="al_right">Sub Total</td>
									<td class="al_right">{{ type.total_amount | toCurrency }}</td>
									<td></td>
								</tr>
							</template>
							<tr>
								<td colspan="5" class="al_right">Grand Total</td>
								<td class="al_right">{{ grandTotal | toCurrency }}</td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</template>
				<template v-else>
					<table class="list_tbl sticky_list_tbl" v-columns-resizable>
						<thead>
							<tr>
								<th width="20%">Receipt Type</th>
								<th width="20%">Amount($)</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<template v-for="date in date_summary_data">
								<tr v-bind:key="date.valid_receipt_date">
									<td colspan="3" class="al_left">
										<b>{{ date.valid_receipt_date }}</b>
									</td>
								</tr>
								<tr v-for="type in date.type_list" v-bind:key="date.valid_receipt_date + '/' + type.type_code">
									<td class="al_center">{{ type.display }}</td>
									<td class="al_right">{{ type.amount | toCurrency }}</td>
									<td></td>
								</tr>
								<tr v-bind:key="date.valid_receipt_date + '/total'">
									<td class="al_center"><b>Sub Total</b></td>
									<td class="al_right">{{ date.total | toCurrency }}</td>
									<td></td>
								</tr>
							</template>
							<tr>
								<td class="al_center"><b>Grand Total</b></td>
								<td class="al_right">{{ grandTotal | toCurrency }}</td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</template>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel()">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiIndex, apiReceiptType } from '@/api/report/report';
import CodeSelect from '@/components/common/CodeSelect';
import { exportDataExcel, objectToFormData } from '@/api/util';
import PartnerSelect from '@/components/common/PartnerSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { today, toDate } from '@/utils/date';
import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			root: [],
			sales_group_code: '',
			salesGroups: [],
			states: [],
			countries: [],
			country: '',
			state: '',
			bill_to_code: '',
			receiptTypeList: '',
			receipt_type: '',
			sort_key: 'bill_to',
			sort_direction: 'ASC',
			from_date: today(),
			to_date: today(),
			itemIndex: 0,
			bounced: false,
			receipt_type_exclude_yn: false,
			valid_only: true,

			search_param: {},
			is_summary: false,
			excel_data: null,
			summary_excel_data: null,

			is_date_summary: false,
			date_summary_data: [],
			date_summary_excel_data: [],
		};
	},
	watch: {
		receipt_type: {
			handler() {
				if (!this.receipt_type) this.receipt_type_exclude_yn = false;
			},
		},
	},
	components: {
		CodeSelect,
		PartnerSelect,
		CustomDatePicker,
	},
	methods: {
		async selectData() {
			const paramObj = {
				sales_group_code: this.sales_group_code || '',
				receipt_type: this.receipt_type || '',
				bill_to_code: this.bill_to_code || '',
				from_date: this.from_date || '',
				to_date: this.to_date || '',
				sort_key: this.sort_key || '',
				sort_direction: this.sort_direction || '',
				bounced: this.bounced ? 'Y' : 'N',
				receipt_type_exclude_yn: this.receipt_type_exclude_yn ? 'Y' : 'N',
				valid_only: this.valid_only ? 'Y' : 'N',
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiReceiptType(param);
			this.root = data.value;
			this.itemIndex = 0;
			this.search_param = paramObj;

			this.convertData();
			this.makeDateSummaryData();
			this.makeDateSummaryExcelData();
		},
		convertData() {
			// 누가 납부했는지 저장하는 컬럼이 없기 때문에 receipt_ar이 참조하는 invoice의 bill_to_code를 납부자로 봄.
			// 데이터베이스 구조상으로는 다른 사람의 Invoice Amt를 대납할 수 있는데, 그럴 경우 한 개의 Receipt에 대하여 납부자가 여러 명일 수 있음.
			// => 현재 여러 Invoice를 묶어서 여러 수단으로 납부하는 경우, 1개의 납입수단으로 n개의 invoice를 결제하는 receipt데이터 set이 insert되고,
			//		최종적으로 결제가 안된 invoice 1개만 남은 경우, 남은 납입수단 n개로 invoice를 결제하는 receipt데이터 set이 insert됨.
			//		1개의 receipt 데이터에 대한 receipt_ar: receipt_item은 1:n 혹은 n:1 만 허용

			this.excel_data = [];
			this.summary_excel_data = [];
			let index = 1;
			if (!Array.isArray(this.root)) return;

			for (const type of this.root) {
				if (!Array.isArray(type.receiptTypeDateList)) continue;

				this.excel_data.push({ receipt_type_code: type.receipt_type_code + ' ' + type.receipt_type_name });
				this.summary_excel_data.push({ receipt_type_code: type.receipt_type_code + ' ' + type.receipt_type_name });

				for (const receipt of type.receiptTypeDateList) {
					if (!Array.isArray(receipt.billList)) continue;

					for (const bill of receipt.billList) {
						bill.summary_list = [];
						if (!Array.isArray(bill.receiptItemList)) continue;

						let prevRi = null;
						for (const ri of bill.receiptItemList) {
							let idx = bill.summary_list.findIndex(s => s.receipt_item_no === ri.receipt_item_no);
							if (idx < 0) {
								bill.summary_list.push({
									index: index,
									receipt_item_no: ri.receipt_item_no,
									receipt_item_amount: ri.receipt_item_amount,
									check_no: ri.check_no,
									post_check_yn: ri.post_check_yn,
									post_check_date: ri.post_check_date,
									bounce_yn: ri.bounce_yn,
									bounce_date: ri.bounce_date,
									bounce_invoice_no: ri.bounce_invoice_no,
								});

								this.summary_excel_data.push({
									index: index,
									receipt_type_code: type.receipt_type_code,
									valid_receipt_date: receipt.valid_receipt_date,
									bill_to_code: bill.bill_to_code,
									bill_to_name: bill.bill_to_name,
									receipt_item_amount: ri.receipt_item_amount || null,
									check_no: ri.check_no,
								});

								index++;
							}

							const obj = {};
							obj.index = ri.index;
							obj.receipt_type_code = type.receipt_type_code;

							obj.invoice_dn = ri.invoice_dn;
							obj.invoice_amount = ri.invoice_amount;
							obj.ar_amount = ri.ar_amount;
							obj.check_no = ri.check_no;
							obj.payment_term_code = ri.payment_term_code;
							obj.past_due_date = ri.past_due_date;
							obj.receipt_remark = ri.receipt_remark;

							if (!prevRi || ri.receipt_item_no !== prevRi.receipt_item_no) {
								obj.valid_receipt_date = receipt.valid_receipt_date;
								obj.sales_group_name = bill.sales_group_name;
								obj.bill_to_code = bill.bill_to_code;
								obj.bill_to_name = bill.bill_to_name;
								obj.bill_address_state = bill.bill_address_state;
								obj.receipt_item_amount = ri.receipt_item_amount || null;
							}

							this.excel_data.push(obj);

							prevRi = ri;
						}
					}
				}
				this.excel_data.push({ index: 'Sub Total', receipt_item_amount: type.total_amount });
				this.summary_excel_data.push({ index: 'Sub Total', receipt_item_amount: type.total_amount });
			}
			this.excel_data.push({
				index: 'Grand Total',
				receipt_item_amount: this.grandTotal,
				invoice_dn: null,
				invoice_amount: null,
				ar_amount: null,
				check_no: null,
				payment_term_code: null,
				past_due_date: null,
				receipt_remark: null,
			});
			this.summary_excel_data.push({ index: 'Grand Total', receipt_item_amount: this.grandTotal, check_no: null });
		},
		makeDateSummaryData() {
			const date_summary = []; // [{ valid_receipt_date: '...', total: ..., type_list: [{ type_code: '...', display: '...', amount: ... }, ...] }, ... ]
			if (!Array.isArray(this.root)) {
				this.date_summary_data = [];
				return;
			}

			for (const type of this.root) {
				if (!Array.isArray(type.receiptTypeDateList)) continue;

				for (const receipt of type.receiptTypeDateList) {
					if (!Array.isArray(receipt.billList)) continue;

					const idx = date_summary.findIndex(el => el.valid_receipt_date === receipt.valid_receipt_date);
					const receipt_item_no_list = []; // 이미 가산된 receipt_item의 금액이 중복으로 가산되는 것을 막기 위함.
					for (const bill of receipt.billList) {
						if (!Array.isArray(bill.receiptItemList)) continue;

						for (const ri of bill.receiptItemList) {
							if (receipt_item_no_list.indexOf(ri.receipt_item_no) > -1) continue;

							receipt_item_no_list.push(ri.receipt_item_no);
							const added_obj = {
								type_code: type.receipt_type_code,
								display: type.receipt_type_code + ' ' + type.receipt_type_name,
								amount: ri.receipt_item_amount,
							};

							if (idx > -1) {
								const type_idx = date_summary[idx].type_list.findIndex(el => el.type_code === type.receipt_type_code);
								if (type_idx > -1) date_summary[idx].type_list[type_idx].amount += ri.receipt_item_amount;
								else date_summary[idx].type_list.push(added_obj);
							} else {
								date_summary.push({
									valid_receipt_date: receipt.valid_receipt_date,
									type_list: [added_obj],
								});
							}
						}
					}
				}
			}

			date_summary.forEach(ds => {
				ds.total = ds.type_list.reduce((prev, curr) => prev + curr.amount, 0);
				ds.type_list.sort((a, b) => {
					const a_code = a.type_code;
					const b_code = b.type_code;
					if (a_code < b_code) return -1;
					else if (a_code > b_code) return 1;
					else return 0;
				});
			});

			// valid_receipt_date로 sort
			date_summary.sort((a, b) => {
				const a_date = toDate(a.valid_receipt_date);
				const b_date = toDate(b.valid_receipt_date);
				if (a_date < b_date) return -1;
				else if (a_date > b_date) return 1;
				else return 0;
			});

			this.date_summary_data = date_summary;
		},
		makeDateSummaryExcelData() {
			// [{ valid_receipt_date: '...', total: ..., type_list: [{ type_code: '...', display: '...', amount: ... }, ...] }, ... ]
			const excel_data = [];
			this.date_summary_data.forEach(date => {
				excel_data.push({ type: date.valid_receipt_date, amount: null });
				date.type_list.forEach(type => {
					excel_data.push({ type: type.display, amount: type.amount });
				});
				excel_data.push({ type: 'Sub Total', amount: date.total });
			});
			excel_data.push({ type: 'Grand Total', amount: this.grandTotal });

			this.date_summary_excel_data = excel_data;
		},
		async changeTable(summary_type) {
			this.$store.commit('setLoading', true);

			const controll_spinner = () => {
				return new Promise(resolve => {
					setTimeout(() => {
						let unchecked = null;
						if (summary_type === 'BILLTO') {
							this.is_date_summary = false;
							this.is_summary = !this.is_summary;
							unchecked = this.$refs.summary_date;
						} else {
							this.is_summary = false;
							this.is_date_summary = !this.is_date_summary;
							unchecked = this.$refs.summary_bill_to;
						}
						unchecked.checked = false;

						resolve();
					}, 500);
				});
			};

			await controll_spinner();
			this.$nextTick(() => this.$store.commit('setLoading', false));
		},
		async index() {
			const { data } = await apiIndex();
			this.salesGroups = data.salesGroupList;
			this.states = data.stateList;
			this.countries = data.countryList;
			this.receiptTypeList = data.receiptTypeList;
		},
		setPartner(partner) {
			this.bill_to_code = partner.code;
		},
		reset() {
			this.sales_group_code = '';
			this.country = '';
			this.state = '';
			this.bill_to_code = '';
			this.receipt_type = '';
			this.sort_key = 'bill_to';
			this.sort_direction = 'ASC';
			this.from_date = today();
			this.to_date = today();
			this.bounced = false;
			this.receipt_type_exclude_yn = false;
			this.valid_only = true;
			this.is_summary = false;
			this.is_date_summary = false;
		},
		lineNumber() {
			this.itemIndex += 1;
			return this.itemIndex;
		},
		excel() {
			let headers = null;
			if (!this.is_date_summary) {
				if (!this.is_summary) {
					headers = [
						{ key: 'index', name: 'No.', width: 15, dataType: defaultDataType.currency },
						{ key: 'receipt_type_code', name: 'Receipt Type', width: 20, dataType: defaultDataType.string },
						{ key: 'valid_receipt_date', name: 'Valid Receipt Date', width: 15, dataType: defaultDataType.string },
						{ key: 'sales_group_name', name: 'Sales Group', width: 15, dataType: defaultDataType.string },
						{ key: 'bill_to_code', name: 'Bill To', width: 15, dataType: defaultDataType.string },
						{ key: 'bill_to_name', name: 'Bill To Name', width: 25, dataType: defaultDataType.string },
						{ key: 'bill_address_state', name: 'STATE', width: 10, dataType: defaultDataType.string },
						{ key: 'receipt_item_amount', name: 'Receipt Amt.', width: 15, dataType: defaultDataType.number },
						{ key: 'invoice_dn', name: 'Billing No.', width: 15, dataType: defaultDataType.string },
						{ key: 'invoice_amount', name: 'Invoice Amt.', width: 15, dataType: defaultDataType.number },
						{ key: 'ar_amount', name: 'AR Amount', width: 15, dataType: defaultDataType.number },
						{ key: 'check_no', name: 'Check No.', width: 15, dataType: defaultDataType.string },
						{ key: 'payment_term_code', name: 'Payment Term', width: 15, dataType: defaultDataType.string },
						{ key: 'past_due_date', name: 'Past Due Date', width: 15, dataType: defaultDataType.currency },
						{ key: 'receipt_remark', name: 'Receipt Remark', width: 30, dataType: defaultDataType.string },
					];

					exportDataExcel(this.excel_data, headers, 'ReceiptStatusByType');
				} else {
					headers = [
						{ key: 'index', name: 'No.', width: 15, dataType: defaultDataType.currency },
						{ key: 'receipt_type_code', name: 'Receipt Type', width: 20, dataType: defaultDataType.string },
						{ key: 'valid_receipt_date', name: 'Valid Receipt Date', width: 15, dataType: defaultDataType.string },
						{ key: 'bill_to_code', name: 'Bill To', width: 15, dataType: defaultDataType.string },
						{ key: 'bill_to_name', name: 'Bill To Name', width: 25, dataType: defaultDataType.string },
						{ key: 'receipt_item_amount', name: 'Receipt Amt.', width: 15, dataType: defaultDataType.number },
						{ key: 'check_no', name: 'Check No.', width: 15, dataType: defaultDataType.string },
					];

					exportDataExcel(this.summary_excel_data, headers, 'ReceiptStatusByType_BillTo_Summary');
				}
			} else {
				headers = [
					{ key: 'type', name: 'Receipt Type', width: 20, dataType: defaultDataType.string },
					{ key: 'amount', name: 'Amount', width: 15, dataType: defaultDataType.number },
				];

				exportDataExcel(this.date_summary_excel_data, headers, 'ReceiptStatusByType_Date_Summary');
			}
		},
		sortMark: function(sort_key) {
			if (this.sort_key === sort_key) return this.sort_direction === 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key === sort_key) {
				this.sort_direction = this.sort_direction === 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectData();
			//console.log(sort_key);
		},
	},
	computed: {
		grandTotal: function() {
			let total = 0;
			this.root.forEach(function(value) {
				total += value.total_amount;
			});
			return total;
		},
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},
	},

	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_receiptType');
		this.$store.commit('setSubTitle', 'Report -> Receipt Status By Receipt Type');
		this.index();
	},
};
</script>

<style scoped></style>
